import { PracticePatientTreatmentQueueService } from 'src/app/api/proxy/practice/services/practice-patient-treatment-queue.service';

export function extractUrlNoParams(url: string): string {
  const idx = url.indexOf('{');
  return idx === -1 ? url : url.substring(0, idx);
}

/**
 * Literal tail after the last route parameter, so paths that share a prefix
 * (e.g. everything under /PatientTreatmentQueue/) can be matched individually.
 */
export function extractUrlAfterParams(url: string): string {
  const idx = url.lastIndexOf('}');
  return idx === -1 ? url : url.substring(idx + 1);
}

export function matchesHiddenLoadingUrl(url: string, fragments: string[]): boolean {
  return fragments.some((fragment) => fragment.length > 0 && url.includes(fragment));
}

/**
 * Queue endpoints that skip the global overlay.
 * `/Queued` is omitted here; Welcome skips the overlay on that call via request context.
 */
export function treatmentQueueHiddenLoadingFragments(): string[] {
  return [
    extractUrlAfterParams(
      PracticePatientTreatmentQueueService.PatientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGetPath,
    ),
    extractUrlAfterParams(
      PracticePatientTreatmentQueueService.PatientTreatmentQueuePatientIdTreatmentQueuesGetPath,
    ),
    extractUrlAfterParams(
      PracticePatientTreatmentQueueService.PatientTreatmentQueuePatientIdHasQueuedGetPath,
    ),
  ];
}
